import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDoor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDoor"><Path d="M2.5 21.5L21.5 21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4.5 21.5V2.5H19.5V21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 12.5H8.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDoor;
